import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('ep-button-group')
export class EPButtonGroup extends LitElement {

  @property({ type: Boolean, reflect: true })
  clickable: boolean = false;

  render() {
    return html`
      <slot></slot>
    `
  }

  static styles = css`
    :host {
      display: inline-flex;
      vertical-align: middle;
      isolation: isolate;
    }

    ::slotted(*) {
      /* border-right-width: 0px; */
      margin-right: -1px;
    }

    ::slotted(:first-child) {
      margin-right: 0px;
      position: relative;
      margin-right: -1px;
      /* border-right-width: 0px; */
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }

    ::slotted(:last-child) {
      margin-left: 0px;
      position: relative;
      border-right-width: 1px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }

    ::slotted(:not(:first-child):not(:last-child)) {
      border-radius: 0px;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-button-group': EPButtonGroup
  }
}
